import Insight from "../insightClass";
import React from "react";
import { insight25Media } from "../../../assets/assetReference";
import { ContactSubscribe } from "../../../components/Contact/Contact";
export const insight079 = new Insight(
  "28 November 2025",
  {
    pageTitle: "Global Offshore Wind Weekly",
    metaDescription: "WeBridge Insights, Global Offshore Wind Weekly",
    keyWords:
      "European Offshore Wind Market development, Global Offshore Wind Weekly",
  },
  {
    src: insight25Media[0],
    alt: "offshore wind turbine",
  },
  "Global Offshore Wind Weekly (2025-11-28)",
  "",
  ` A new industry report warns that repeated delays across UK offshore energy infrastructure are threatening the long-term viability of the country’s offshore wind and subsea supply chain. In the 2025 Business Survey by Global Underwater Hub (GUH), 96% of supply chain participants stated that activity in offshore wind, oil & gas and defence is progressing too slowly to meet the UK’s transition goals. A further 82% of respondents believe the gap between supply chain capacity and real project demand is widening.`,
  <div>
    <strong>WeBridge Insights</strong>
    <h1>Global Offshore Wind Weekly (2025-11-28)</h1>
    <h2></h2>
    <p className="article-date">28 November 2025</p>
    <br />
    <p>
      Welcome to this week's <i>WeBridge Insights</i>, where we provide you with
      the latest updates and key developments from the global offshore wind
      market.
    </p>
    <br />
    <br />
    <br />
    <p>
      At <b>WeBridge</b>, we deliver forward-thinking analysis and expert
      commentary to keep you informed in this fast-evolving industry. Here's our
      roundup of the top stories this week, complete with professional insights
      to help you stay ahead:
    </p>
    <h3>
      1. UK Offshore Wind Supply Chain Warns of a “Cliff Edge” as Project Delays
      Intensify
    </h3>
    <p>
      A new industry report warns that repeated delays across UK offshore energy
      infrastructure are threatening the long-term viability of the country’s
      offshore wind and subsea supply chain. In the 2025 Business Survey by
      Global Underwater Hub (GUH), 96% of supply chain participants stated that
      activity in offshore wind, oil & gas and defence is progressing too slowly
      to meet the UK’s transition goals. A further 82% of respondents believe
      the gap between supply chain capacity and real project demand is widening.
    </p>
    <p>
      The report argues that the UK is creating a “vacuum of inactivity” which
      may be filled by international markets with more predictable pipelines.
      Vessel owners, fabrication yards and specialised engineering firms are
      already considering pivoting towards continental Europe or Asia to avoid
      idle capacity. Once these assets and skills exit the UK market, GUH warns,
      they may not return—even when domestic offshore wind demand rebounds.
    </p>
    <p>
      Ahead of the Autumn Budget, GUH calls for accelerated project execution,
      clear long-term policy signals, strengthened skills pipelines and
      strategic diversification incentives. Without coordinated action, the UK
      risks repeating historic cycles of boom-and-bust within its offshore
      industrial base.
    </p>
    <p>
      <b>WeBridge Insights</b>
    </p>
    <p>
      This is a structural warning, not a temporary slowdown. The UK is
      simultaneously relying on offshore wind for its 2030 decarbonisation
      goals, demanding that suppliers invest in capacity for larger projects and
      larger turbines, while also failing to deliver a predictable build-out
      pipeline.
    </p>
    <p>Key implications include:</p>
    <ul className="list-disc my-6">
      <li>
        Rising delivery and pricing risk for foundation, cable and installation
        packages.
      </li>
      <li>
        Suppliers increasinglyadopting multi-market portfolios to reduce UK
        exposure.
      </li>
      <li>
        Increased competition from European and Asian contractors for UK-origin
        yards and vessels.For our clients, the UK remains attractive—but project
        screening must now incorporate policy timing and supply chain continuity
        risk as core variables.
      </li>
    </ul>
    <h3>2. UK Sets New All-Time Wind Generation Record: 22.7GW</h3>
    <p>
      The UK set a new national wind generation record, reaching 22,711MW at
      19:30 on 11 November—enough to power more than 22 million homes. Wind
      accounted for 43.6% of national electricity demand during the peak period,
      surpassing the previous record set in December 2024.
    </p>
    <p>
      The milestone reflects particularly strong offshore wind output due to its
      higher load factors. It comes at a politically sensitive moment as
      government faces increasing pressure over whether its current auction
      design and CfD budgets can deliver the 43–50GW offshore wind target for
      2030.
    </p>
    <p>
      The record also underscores the growing need for flexibility
      solutions—interconnectors, long-duration storage, and demand-side
      management—to absorb high renewable penetration and avoid curtailment.
      Transmission constraints in Scotland and the North Sea remain key
      bottlenecks.
    </p>
    <p>
      <b>WeBridge Insights</b>
    </p>
    <p>
      Record wind output is good news—but it also exposes the limits of the
      existing system architecture.
    </p>
    <p>
      Grid constraints will increasingly determine project economics, not just
      turbine performance.
    </p>
    <p>
      Curtailment risk must be quantitatively modelled for site selection and
      PPA negotiations.
    </p>
    <p>
      Corporate PPA demand (especially from data centres) is set to become a
      stabilising force for offshore wind revenue stacks.For investors and
      developers, the headline record reinforces a crucial point: system value,
      not megawatt volume, will be the defining theme of the next UK offshore
      wind cycle.
    </p>
    <h3>
      3. 2GW Spittal–Peterhead Subsea Link Receives Marine Licence,
      Strengthening Scottish Grid Access
    </h3>
    <p>
      SSEN Transmission has secured a key marine licence for the 2GW subsea
      transmission link connecting Spittal (Caithness) to Peterhead
      (Aberdeenshire). The 100-mile route will play a central role in enabling
      large-scale Scottish offshore wind projects—including ScotWind and
      INTOG—to export power to demand centres further south.
    </p>
    <p>
      The project is part of SSEN’s £22bn programme to reinforce the north of
      Scotland’s transmission infrastructure. Onshore contracts have already
      been awarded to regional firms, supporting local employment. The marine
      licence follows extensive stakeholder consultation, reflecting the
      increasing complexity of environmental and community engagement for grid
      infrastructure.
    </p>
    <p>
      <b>WeBridge Insights</b>
    </p>
    <p>
      This project highlights the strategic pivot from seabed to transmission
      availability as the dominant constraint in UK offshore wind.
    </p>
    <p>
      Projects connecting into this corridor will enjoy significantly better
      curtailment outlooks.
    </p>
    <p>
      Grid-related social licence issues will increasingly shape development
      timelines.
    </p>
    <p>
      Developers must integrate grid capacity modelling into bid strategy and
      FID analysis far earlier than before.In the North Sea basin, the winners
      will be those who optimise around both seabed and grid timing—not one or
      the other.
    </p>
    <h3>
      4. Ørsted–ESB Secure 900MW Tonn Nua CfD in Ireland’s Second Offshore
      Auction
    </h3>
    <p>
      Ireland has provisionally awarded Ørsted and ESB the rights to develop the
      900MW Tonn Nua offshore wind farm off the Waterford coast. The project is
      the sole winner of the Tonn Nua ORESS round—Ireland’s second offshore
      auction and its first under the state-led planning regime.
    </p>
    <p>
      The joint venture secured a 20-year CfD at €98.719/MWh. The project will
      now move into its stage-gate process, with a final investment decision
      expected around 2031 and first power in the mid-2030s. EirGrid will be
      responsible for developing offshore and onshore transmission
      infrastructure.
    </p>
    <p>
      <b>WeBridge Insights</b>
    </p>
    <p>Tonn Nua is a strategically important signal for investors:</p>
    <ul className="list-disc my-6">
      <li>
        It sets a clear price benchmark for fixed-bottom offshore wind in
        Ireland under elevated capex conditions.
      </li>
      <li>
        It validates Ireland’s state-led planning framework, which may reduce
        early-stage risk relative to pure developer-led models.
      </li>
      <li>
        It further diversifies Ørsted’s European footprint after challenges in
        the US market.Ireland—the Celtic Sea in particular—is emerging as a
        long-dated but investable region, with significant overlap between Irish
        and UK supply chain development.
      </li>
    </ul>
    <h3>
      5. Vestas’ First 15MW Turbine Produces Power at Germany’s He Dreiht
      Project
    </h3>
    <p>
      Vestas has energised its first 15MW offshore turbine at the He Dreiht
      project in the German North Sea—Germany’s largest offshore wind farm and
      one of Europe’s flagship next-generation developments.
    </p>
    <p>
      With a hub height of 142m and a rotor diameter of 236m, the turbine
      represents one of the world’s largest commercially deployed units. EnBW
      has installed 27 of the planned 64 turbines, with full commissioning
      expected by summer 2026. The project is connected via TenneT’s offshore
      converter platform, enabling high-efficiency export of power to shore.
    </p>
    <p>
      <b>WeBridge Insights</b>
    </p>
    <p>He Dreiht will shape the next decade of turbine procurement strategy:</p>
    <ul className="list-disc my-6">
      <li>
        LCOE advantages from larger turbines are real, but so is concentration
        of technical risk.
      </li>
      <li>
        Vessel capability, crane height and port infrastructure are being pushed
        to their limits—execution challenges here will influence vessel
        day-rates and future EPCI scheduling assumptions.
      </li>
    </ul>

    <p>
      If the 15MW class performs as expected, 15–20MW turbines will become the
      new standard for late-2020s European projects.For developers entering
      auctions in Germany, the UK, France and Taiwan, He Dreiht is a crucial
      reference point for risk-adjusted turbine selection.
    </p>
    <h3>
      6. Floating Offshore Wind Momentum: Celtic Sea Masterplan and Norway’s New
      State-Aid Scheme
    </h3>
    <p>
      Two major developments highlight growing momentum behind floating offshore
      wind (FLOW) in Europe.
    </p>
    <ol>
      <li>
        <b>Celtic Sea Power</b> released a comprehensive regional masterplan
        outlining the infrastructure, policy and testing capacity required to
        unlock FLOW deployment in the Celtic Sea. Port upgrades, fabrication
        capacity and enhanced testing and demonstration facilities are
        identified as immediate priorities.
      </li>
      <li>
        <b>Norway</b> received approval for a new national support scheme under
        the Clean Industrial State Aid Framework. The programme will provide up
        to £743m in competitive tenders until 2030 to accelerate floating wind
        demonstration and early-stage commercial projects.
      </li>
    </ol>
    <p>
      <b>WeBridge Insights</b>
    </p>
    <p>Europe is shifting from ambition to implementation in floating wind:</p>
    <ul className="list-disc my-6">
      <li>
        Policy now targets hard enablers—ports, grids, test sites—rather than
        generic capacity targets.
      </li>
      <li>
        Distinct regional clusters are emerging: a UK–Ireland–France Celtic Sea
        cluster, and a Norway-anchored North Atlantic demonstration hub.
      </li>
    </ul>
    <p>
      Future auction designs may increasingly reward industrial commitment,
      including port investment and participation in testing programmes.For
      supply chain players, FLOW is entering a pre-industrialisation phase in
      which early positioning will determine long-term regional leadership.
    </p>
    <h3>
      7. EDF Considers Selling 50–100% of Its US Renewables Unit After Atlantic
      Shores Write-Down
    </h3>
    <p>
      EDF is considering selling between 50% and 100% of its US renewables
      business as it shifts capital towards expanding its French nuclear fleet.
      A full sale could value the unit at around €4bn. The company faces a
      substantial debt burden and recently wrote down nearly €900m on its
      Atlantic Shores offshore wind joint venture with Shell, following a
      moratorium on new US offshore wind development.
    </p>
    <p>
      EDF’s US renewables arm includes a 23GW development pipeline and 16GW
      under service agreements across North America. The potential sale
      underscores the impact of US political and regulatory volatility on the
      economics of offshore wind investments.
    </p>
    <p>
      <b>WeBridge Insights</b>
    </p>
    <p>This is a significant strategic pivot with global implications:</p>
    <ul className="list-disc my-6">
      <li>
        European utilities may become more cautious about large-scale US
        offshore wind exposure without improved regulatory stability.
      </li>
      <li>
        Valuation outcomes from this sale will influence future M&A pricing for
        US offshore portfolios.
      </li>
      <li>
        These shifts open opportunity for buyers with a longer-term view of US
        market recovery.
      </li>
    </ul>
    <p>
      For international developers and investors, the key lesson is to
      incorporate political-regulatory stress cases as core inputs—not
      peripheral sensitivities—in US offshore wind strategy.
    </p>
    <br />
    <br />
    <br />
    <p>
      As the global offshore wind sector continues to advance, innovation,
      investments, and supportive policies are driving transformative growth. At{" "}
      <i>
        <b>WeBridge</b>
      </i>
      , we provide the expertise and insights our partners need to confidently
      navigate this evolving landscape.
    </p>
    <h3 style={{ marginTop: "200px" }}>Subscribe</h3>
    <ContactSubscribe />
  </div>,
);
